<template>
  <v-container v-resize="getWindowWidth">
    <v-layout wrap>
      <v-flex xs12 pt-4>
        <v-card>
          <v-card-title>
            <v-row>
              <v-col
                cols="10"
              >
                {{ $t('settings.title') }}
              </v-col>
              <v-col
                cols="2"
              >
                <v-btn
                  color="primary"
                  @click="toggleDrawer(true)"
                >
                  {{ $t('settings.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="terms"
            class="elevation-1"
            :items-per-page="25"
            :items-per-page-options="[25, 50, 100, -1]"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td @click="openEditDrawer(item)">
                  {{ item.id }}
                </td>
                <td @click="openEditDrawer(item)">
                  <span>
                    {{ getCountryName(item.country_id) }}
                  </span>
                </td>
                <td @click="openEditDrawer(item)">
                  <v-icon
                    :color="item.is_default ? 'success' : 'gray'"
                  >
                    check_circle
                  </v-icon>
                </td>
                <td>
                  <v-btn
                    icon
                    @click="showConfirmDelete(item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-navigation-drawer
      :value="termsDrawer"
      :permanent="termsDrawer"
      temporary
      fixed
      right
      :width="width"
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
      class="bg-gray"
    >
      <NewTerms
        v-show="termsDrawer"
        @close="toggleDrawer(false)"
      />
    </v-navigation-drawer>
    <BaseConfirmDialog
      v-if="dialog"
      :title="$t('settings.delete_term')"
      :description="$t('settings.delete_term_description')"
      :accept-text="$t('settings.accept')"
      :cancel-text="$t('settings.cancel')"
      @close="cancel"
      @proceed="confirmDelete"
    />
  </v-container>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import NewTerms from '@/components/Terms/NewTerms'
import BaseConfirmDialog from '@/components/BaseConfirmDialog'

export default {
  name: 'TermsAndConditions',
  components: { NewTerms, BaseConfirmDialog },
  async created () {
    await this.getCountries()
    await this.getTerms()
  },
  data () {
    return {
      dialog: false,
      selectedTerm: null,
      width: '95%',
      headers: [
        {
          text: 'ID',
          value: 'id',
          class: 'text-no-wrap blue--text text--darken-4',
          width: '20%'
        },
        {
          text: this.$t('settings.table.country'),
          value: 'country_id',
          class: 'text-no-wrap blue--text text--darken-4',
          width: '50%'
        },
        {
          text: this.$t('settings.table.is_default'),
          value: 'is_default',
          class: 'text-no-wrap blue--text text--darken-4',
          width: '15%'
        },
        {
          text: '',
          value: '',
          class: 'text-no-wrap blue--text text--darken-4',
          width: '15%'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      countries: ({ countries: { countries } }) => countries,
      terms: ({ terms: { terms } }) => terms,
      termsDrawer: ({ terms: { drawer } }) => drawer
    })
  },
  methods: {
    ...mapActions({
      getTerms: 'terms/getTerms',
      getCountries: 'countries/getCountries',
      deleteTerm: 'terms/deleteTerm'
    }),
    ...mapMutations({
      toggleDrawer: 'terms/toggleDrawer',
      setTerm: 'terms/setTerm'
    }),
    openEditDrawer (term) {
      this.setTerm(term)
      this.toggleDrawer(true)
    },
    getCountryName (country_id) {
      let country = this.countries.find(c => c.id === country_id)
      return country.name
    },
    getWindowWidth () {
      if (process.client) {
        this.width = window.innerWidth > 800 ? window.innerWidth * 0.94 : window.innerWidth
      }
    },
    cancel () {
      this.selectedTerm = null
      this.dialog = false
    },
    showConfirmDelete(term_id) {
      this.selectedTerm = term_id
      this.dialog = true
    },
    confirmDelete () {
      this.dialog = false
      this.deleteTerm(this.selectedTerm)
        .then(
          res => {
            this.selectedTerm = null
            this.$noty.success(this.$t('settings.messages.delete_success'))
          },
          err => {
            this.$noty.error(this.$t('settings.messages.delete_error'))
          }
        )
    },
  }
}
</script>

<style>

</style>